import React, { FC } from 'react';
import { cx } from 'linaria';
import { PriceMainProps } from 'common/components/product-price-view/types';
import { getLocale } from 'utils';
import { isValues, setProps } from '../utils';
import { APriceView } from '../a-price-view';

export type FirstPriceViewProps = {
  price: PriceMainProps;
  className?: string;
  oldNewPriceClassName?: string;
  isBestPrice?: boolean;
  hasThreePrices?: boolean;
  isStickyPanel?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const FirstPriceView: FC<FirstPriceViewProps> = ({
  price,
  className,
  oldNewPriceClassName,
  isBestPrice,
  hasThreePrices,
  isStickyPanel,
  ...htmlProps
}) => {
  const locale = getLocale();

  return (
    <>
      {isValues(price) ? (
        <APriceView
          className={cx(className, 'primary-price')}
          oldNewPriceClassName={oldNewPriceClassName}
          name="primary"
          isBestPrice={isBestPrice}
          hasThreePrices={hasThreePrices}
          isStickyPanel={isStickyPanel}
          {...setProps({ ...price, locale })}
          {...htmlProps}
        />
      ) : null}
    </>
  );
};
